<template>
  <div class="card" v-if="updating_metrics.visibleFlag === true" :style="{ width: myWidth + '%' }">
    <div class="card-header d-flex justify-content-between">
      <div class>{{updating_metrics.vizTitle}}</div>


      <a v-on:click="commentBox(updating_metrics)" class="txt-color-white right-padding-50">
        <i class="fa fa-lg fa-comments"></i>
      </a>
    </div>
    <div class="card-body">
      <div :id="id" ref="r1c1" class="mb-5" >
        <div id="charts">
        <div class="btn-group btn-group-sm text-center split-by-controls">
             <button type="button" class="btn btn-secondary active" data-y_accessor="metric1"  data-time_period="">All time</button>
             <button type="button" class="btn btn-secondary" data-y_accessor="metric2"  :data-time_period="updating_metrics.clientId==10?12:28">{{button2Title}}</button>
             <button type="button" class="btn btn-secondary" data-y_accessor="metric3"  :data-time_period="updating_metrics.clientId==10?6:7">{{button3Title}}</button>
         </div>
         </div>
          <div id="split_by" class="chart split-by-controls">
           </div>
          <div id="modify_markers" class="chart split-by-controls">
          </div>
          <div id="modify_time_period" class="chart split-by-controls">
        </div>
      </div>
    </div>

    <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
      <b-form-group label="Comment">
        <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
import {FwVizChartInfo} from "../models";
import axios from "axios";

export default {
  name: "updating_metrics",
  props: {
    updating_metrics: Object
  },
  data: () => ({
    salesmanData: [],
    filterSalesman: "",
    showModal: false,
    cmnt: "",
    annotations: [],
    searching: false,
    annotationTitle: "",
    button2Title: "",
    button3Title: ""
  }),
  methods: {
    loadSalesman: function() {
      axios.get("/api/salesman-list/").then(
        res => {
          this.salesmanData = res.data;
          this.filterSalesman = Array.from(
            new Set(this.salesmanData.map(c => c.dim1).filter(x => x != null))
          );
          console.log("Salesman data:", this.filterSalesman);
        },
        err => {
          console.log("Error in fetching record", err);
        }
      );
    },

    commentBox: function(what) {
      console.log(
        `ENTERED into the commentBox function(${what.menuName}, ${what.screenName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = what.screenTitle;
      this.annotationHeader = "User Annotations";
      this.annotationTitle =
        this.annotationHeader + "->" + this.pg + "->" + this.section;
      this.$refs["comment-box"].show();
    },

    postAnnotation: function() {
      const url = "/api/annotation";

      const data = {
        userId: 1,
        userName: "Admin",
        page: this.pg,
        section: this.section,
        comment: this.cmnt
      };
      axios.post(url, data).then(
        () => {
          this.$store.dispatch("loadAnnotations");
        },
        e => {
         // this.$commonFn.auditLog(this.updating_metrics.menuSyspk,menu, subMenu, "", "POST", e);
          console.error("error in updating annotations", e);
        }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);

     // this.$commonFn.auditLog(this.updating_metrics.menuSyspk,menu, subMenu, "", "POST", "Success");
    }
  },
  created() {

    console.log('upd_met','loading state');this.$store.dispatch("loadState").then(() => {
      let allVizType = this.$store.state.vizType;
      let v = this.updating_metrics;
      let margin = {
        top: v.pmTop,
        right: v.pmRight,
        bottom: v.pmBottom,
        left: v.pmLeft
      };

      let vizId = v.viztypeId;
      let filter = allVizType.filter(t => t.viztypeId === vizId)[0];
    //  let vizname = filter.viztypeName;
       let vizname = filter.viztypeClassName
      let vizFunction = filter.viztypeFunctionName;

      let divId = this.$refs.r1c1;

      this.button2Title=v.clientId==10?"Past 1 Year":"Past 4 Weeks"
      this.button3Title=v.clientId==10?"Past 6 Months":"Past 1 Week"


      let vizunit = v.positionLogical;

      let getChartInfo = vizunit => {
        let f = v;
        if (f.length === 0)
          return new FwVizChartInfo(vizunit, margin, {}, false, []);
        return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
      };

      this.position = getChartInfo(vizunit);

      let chartData = this.position;
      console.log("The chart data is", chartData, vizname, divId);

      setTimeout(() => {
        this.$commonFn.renderChart(vizname, chartData, divId, vizFunction);
      }, 300);
    });
  }
};
</script>
<style>
.cobackground {
  fill: #eee;
}

text.active {
  fill: red;
}
.cScroll {
  height: 500px;
  overflow: scroll;
}
.c-s {
  margin-top: -7px;
  margin-left: 500px;
  height: 30px;
}
</style>